import React, {useState, useEffect} from 'react'
import BannerImg from '../assets/banner-img.png';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import 'swiper/css';
import Makeup from '../assets/makeup.jpg';
import Skincare from '../assets/skincare.jpg';
import Haircare from '../assets/haircare.jpg';
import Bodycare from '../assets/bodycare.jpg';
import BannerBg from '../assets/banner-bg.avif';


const Home = () => {
      const [banners, setBanners] = useState([]);

        useEffect(() => {
          const fetchBanners = async () => {
            try {
              const response = await fetch('https://api.siddhabhairabistore.com/get-banner');
              if (response.ok) {
                const data = await response.json();
                setBanners(data);
              } else {
                console.error('Failed to fetch banners');
              }
            } catch (error) {
              console.error('Error fetching banners:', error);
            }
          };
      
          fetchBanners();
        })
      

    return (
        <>

            {/* banner section */}
            <section className='banner-bg'>
                <div className='container'>

                    <div className='row'>

                        <div className='col-md-6 col-12 my-2 align-content-center'>
                            <p className='banner-heading'>The Future of Cosmetic is here</p>
                            <p className='banner-text'>At Siddha Bhairabi Store, take your pick of the best and newest makeup brands and skin care products</p>
                        </div>

                        <div className='col-md-6 col-12 my-2 text-center'>
                            <img src={BannerImg} className='img-fluid' alt='Banner' />
                        </div>

                    </div>
                    {/* row ends */}

                </div>
            </section>


            <div className='banner-bottom'>

            </div>
            {/* banner section ends */}



{/* Offer banner section */}
<section className='my-5 container'>
              <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel" data-bs-interval="2000">
    <div className="carousel-indicators">
        {banners.length > 0 &&
            banners.map((offer, index) => (
                <button
                    key={index}
                    type="button"
                    data-bs-target="#carouselExampleIndicators"
                    data-bs-slide-to={index}
                    className={index === 0 ? 'active' : ''}
                    aria-label={`Slide ${index + 1}`}
                ></button>
            ))
        }
    </div>

    <div className="carousel-inner rounded">
        {banners.length > 0 ? (
            banners.map((offer, index) => {
                const offerUrl = `https://api.siddhabhairabistore.com/uploads/${offer['image']}`;
                return (
                  <>
                    <div
                        key={index}
                        className={`carousel-item align-content-center ${index === 0 ? 'active' : ''} banner2-bg`}
                        style={{ 
    backgroundImage: `
      linear-gradient(rgba(0, 0, 0, 0.10), rgba(0, 0, 0, 0.70)), 
      url(${offerUrl || BannerBg})
    `,
    // backgroundSize: 'cover',
    // backgroundPosition: 'center',
    // backgroundRepeat: 'no-repeat'
  }}
                    >
                        <div className="container">
                            <p className="banner-text fw-semibold text-light">{offer.offer_tagline}</p>
                            <p className="banner-heading col-md-8 text-light">{offer.offer_name}</p>
                            <p className="col-lg-6 col-md-8 fm-spartan text-light">{offer.description}</p>
                        </div>
                    </div>
                    </>
                );
            })
        ) : (
            <div className="carousel-item active banner2-bg" style={{ backgroundImage: `url(${BannerBg})`}}>
                <div className="container">
                    <p className="banner-text fw-semibold">Get Exciting Deals & Discounts</p>
                    <p className="banner-heading col-md-8">Refine your Beauty</p>
                    <p className="col-lg-6 col-md-8 fm-spartan">
                      Whether you're looking to refresh your skincare routine, try the latest makeup trends, or indulge in self-care, we’ve got you covered.
                    </p>
                </div>
            </div>
        )}
    </div>
</div>
</section>
{/* offer banner section ends */}


            {/* Popular category section */}
            <section className='bg-light py-5'>
                <div className='container'>

                    <p className='sec-heading text-center'>Popular Categories</p>

                    <Swiper spaceBetween={30} slidesPerView={3} modules={[Autoplay, Navigation]} loop={true} className='py-3 px-md-5 px-2'
                        navigation={{ nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }} autoplay={{ delay: 2000 }}
                        breakpoints={{
                            0: {
                                slidesPerView: 1,
                            },
                            768: {
                                slidesPerView: 2,
                            },
                            992: {
                                slidesPerView: 3,
                            }
                        }}>

                        <SwiperSlide>
                            <div className='category-area'>
                                <img src={Makeup} alt='category' className='category-img' />
                                <div className='category-content'>
                                    <p className='category-text'>Makeup & Shine</p>
                                    <p className='text-muted'>Foundation, concealer, blush, highlighter, bronzer,
                                        setting spray/powder, Makeup Palettes & more.</p>
                                    <hr />             </div>
                            </div>
                        </SwiperSlide>

                        <SwiperSlide>
                            <div className='category-area'>
                                <img src={Skincare} alt='category' className='category-img' />
                                <div className='category-content'>
                                    <p className='category-text'>Skincare</p>
                                    <p className='text-muted'>Cleansers, Toners
, Serums (vitamin C, hyaluronic acid, niacinamide, salicylic acid, glycolic gel), Moisturizers, Sunscreen & more.</p>
                                    <hr />             </div>
                            </div>
                        </SwiperSlide>

                        <SwiperSlide>
                            <div className='category-area'>
                                <img src={Haircare} alt='category' className='category-img' />
                                <div className='category-content'>
                                    <p className='category-text'>Hair Care</p>
                                    <p className='text-muted'>Shampoo, Conditioner, Hair Oils & Serums, Hair Masks, Hair Color & Dyes,
                                        Hair Tools (dryers, straighteners, curlers) & more.</p>
                                    <hr />             </div>
                            </div>
                        </SwiperSlide>

                        <SwiperSlide>
                            <div className='category-area'>
                                <img src={Bodycare} alt='category' className='category-img' />
                                <div className='category-content'>
                                    <p className='category-text'>Body Care</p>
                                    <p className='text-muted'>Body Wash & Soaps, Body Lotions & Creams, Body Scrubs, Deodorants, Hand & Foot Care,
                                        Bath Salts & Oils 7 more.</p>
                                    <hr />             </div>
                            </div>
                        </SwiperSlide>

                    </Swiper>
                    {/* row ends */}

                </div>
            </section>
            {/* Popular category section ends */}


{/* banner2 section */}
<section className='banner2-bg'>
    <div className='container text-center'>

<p className='banner-text'>Find Your Beauty Match</p>
<p className='banner-heading'>100% Authentic Products</p>
<button className='banner2-btn animate__animated animate__pulse animate__infinite' onClick={() => window.open('https://play.google.com/store/apps/details?id=com.dectwin.s_store', '_blank')}>Shop Now</button>

    </div>
</section>
{/* banner2 section ends */}

        </>
    )
}

export default Home
